import { sanitizeDashboardReturnTo } from "./returnTo"
import type { AuthTransaction } from "./types"

const AUTH_TRANSACTION_STORAGE_KEY = "playbrain.dashboard.auth.tx.v1"

export function readTransaction(): AuthTransaction | null {
  const raw = getSessionStorage()?.getItem(AUTH_TRANSACTION_STORAGE_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw) as AuthTransaction
  } catch {
    return null
  }
}

export function writeTransaction(transaction: AuthTransaction) {
  getSessionStorage()?.setItem(AUTH_TRANSACTION_STORAGE_KEY, JSON.stringify(transaction))
}

export function clearTransaction() {
  getSessionStorage()?.removeItem(AUTH_TRANSACTION_STORAGE_KEY)
}

function getSessionStorage() {
  if (typeof window === "undefined") return null
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}

export function createTransaction(returnTo: string): AuthTransaction {
  return {
    state: generateRandomString(32),
    codeVerifier: generateRandomString(64),
    returnTo: sanitizeDashboardReturnTo(returnTo),
  }
}

export async function createCodeChallenge(codeVerifier: string): Promise<string> {
  const data = new TextEncoder().encode(codeVerifier)
  const digest = await crypto.subtle.digest("SHA-256", data)
  return base64UrlEncode(new Uint8Array(digest))
}

function generateRandomString(length: number): string {
  const bytes = new Uint8Array(length)
  crypto.getRandomValues(bytes)
  return base64UrlEncode(bytes).slice(0, length)
}

function base64UrlEncode(input: Uint8Array): string {
  let binary = ""
  for (const byte of input) binary += String.fromCharCode(byte)
  return btoa(binary).replaceAll("+", "-").replaceAll("/", "_").replaceAll("=", "")
}
